import { Consts, theme } from '../dependencies';

import plugins from './plugins';
import enhancers from './enhancers';

export const rendererConfig = {
    devMode: Consts.isEnvDevelopment,
    enhancers,
    plugins,
    theme,
};

export const staticCSS = [];

export const fonts = [
    // {
    //     name: '',
    //     files: [],
    //     options: {}
    // }
];
